export default __webpack_public_path__ + "6b04b02185c58fcd8cf66a72fb4dee54.png";